<template>
  <el-dialog title="分配角色"
             :visible.sync="showUser"
             :close-on-click-modal="false"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="userInfo"
               :rules="userRules"
               ref="userForm"
               label-width="90px"
               class="type-form">
        <el-form-item label="系统角色:"
                      prop="user_role">
          <el-checkbox-group v-model="userInfo.user_role">
            <el-checkbox v-for="(item, index) in sysRoleList"
                         :key="index"
                         class="mb-10"
                         :label="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- <el-form-item label="管理角色:"
                      prop="mageRole">
          <el-checkbox-group v-model="userInfo.mageRole">
            <el-checkbox v-for="(item, index) in mageRoleList"
                         :key="index"
                         class="mb-10"
                         :label="item.roleId">{{ item.roleName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
      </el-form>
    </el-col>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/user/edit'"
                 type="primary"
                 @click="handleConfirm('userForm')">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showUser: this.isShow,
      userInfo: {
        user_role: []
        // mageRole: []
      },
      userRules: {
        user_role: [{ required: false, message: '请选择用户系统角色' }]
        // mageRole: [{ required: false, message: '请选择用户管理角色' }]
      },
      sysRoleList: [],
      mageRoleList: []
    }
  },
  created() {
    this.getRole()
    this.getInfo()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getUserInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.userInfo.user_role = data.user_role
              ? data.user_role.split(',')
              : []
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取角色数据
    getRole() {
      fetch.getRoleList({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.sysRoleList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.userInfo))
          datas.user_role = datas.user_role.join(',')
          fetch.editUser({ ...datas, id: this.data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.handleCancel('refresh')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    }
  }
}
</script>

<style></style>
